// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"lIojG":[function(require,module,exports) {
const feedback = document.getElementById("FormFill");
const feedbackStatus = document.getElementById("FormStatus");
const feedbackButton = document.getElementById("FormButton");
let spamtext = "";
feedbackButton.addEventListener("click", submitFeedback);
function enableButton() {
    feedbackButton.removeAttribute("disabled");
    feedbackButton.innerHTML = "Submit";
}
function disableButton() {
    feedbackButton.setAttribute("disabled", null);
    if (feedback.value != "") {
        feedbackButton.innerHTML = "Submitted";
        feedbackStatus.innerHTML = "Thank you for the feedback!";
    }
}
function submitFeedback() {
    // console.log(feedback.value);
    feedbackStatus.innerHTML = "Sending feedback...";
    if (feedback.value == "You and Me") showSecret();
    else {
        fetch(`https://docs.google.com/forms/u/0/d/e/1FAIpQLSf7x_6sWhFNFuHPvO4hW5yxx788PpVLbbSzWcoixIffAQjQjw/formResponse?&entry.1863945483=${feedback.value}&submit=SUBMIT`, {
            method: "POST",
            mode: "no-cors",
            redirect: "follow",
            referrer: "no-referrer"
        }).then((res)=>{
            console.log(res);
            feedbackStatus.innerHTML = "Thank you for the feedback!";
            spamtext = feedback.value;
        }).catch((err)=>{
            console.log(err);
            feedbackStatus.innerHTML = "Response not received.";
        });
        disableButton();
    }
}
feedback.addEventListener("input", ()=>{
    if (feedback.value == spamtext) disableButton();
    else {
        enableButton();
        feedbackStatus.innerHTML = "Not Sent";
    }
    if (feedback.value.includes("June 11th") || feedback.value.includes("06 11")) feedbackStatus.innerHTML = "I love you Nesi <3";
    if (feedback.value == "April 28th") feedbackStatus.innerHTML = "WHAT ARE YOU CHECKING FOR...? ;)";
});
function showSecret() {
    var audio = document.getElementById("audio");
    setTimeout(()=>{
        document.getElementsByClassName("alwaysForever")[0].classList.remove("classClose");
        audio.play();
        feedbackStatus.innerHTML = "Always Forever";
    }, 50);
    document.querySelector(".alwaysForever.classClose").style.setProperty("display", "flex");
    setTimeout(()=>{
        document.getElementsByClassName("alwaysForever")[0].classList.add("classClose");
        setTimeout(()=>{
            document.querySelector(".alwaysForever.classClose").style.setProperty("display", "none");
        }, 1000);
    }, 27000);
}

},{}]},["lIojG"], "lIojG", "parcelRequire2041")

//# sourceMappingURL=index.cf37d18c.js.map
